import { cn } from '../../lib/utils';

export default function DataTableShell({ children, className }) {
  return (
    <div className={cn('overflow-hidden rounded-lg border border-slate-200', className)}>
      <div className="overflow-x-auto">
        {children}
      </div>
    </div>
  );
}
